import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PagesContentRoutingModule } from './pages-content-routing.module';
import { PageContentFormComponent } from './components/page-content-form/page-content-form.component';
import { SharedModule } from '../shared/shared.module';
import { SharedFormSectionsModule } from '../shared-form-sections/shared-form-sections.module';
import { RouterModule } from '@angular/router';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [PageContentFormComponent],
  imports: [
    CommonModule,
    SharedModule,
    SharedFormSectionsModule,
    PagesContentRoutingModule,
    RouterModule,
    MatSnackBarModule,
    MatDialogModule,
  ],
})
export class PagesContentModule {}
